module.exports = __webpack_public_path__ + "img/londres.35d05c67.png";